<template>
  <!-- 首页导航模块 -->
  <div id="main-view" @touchstart.passive="onTouchStart" @touchend.passive="onTouchEnd">
    <el-carousel ref="banner" :height="bannerHeight" trigger="click" arrow="hover">
      <el-carousel-item v-for="(item, index) in slideContent" :key="index">
        <img :src="item.thumb" alt="" class="carousel_img" draggable="false" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  // import Slide from '@/components/Slide'
  import SlideMainView from "@/components/SlideMainView";
  // import SlideSeckill from '@/components/SlideSeckill'
  import SideBar from "@/components/SideBar";
  import FreshNews from "@/components/FreshNews";
  import { slideshow } from '@/api/user'

  export default {
    name: "MainView",
    components: {
      // 'slide': Slide,
      "side-bar": SideBar,
      "fresh-news": FreshNews,
      "slide-main-view": SlideMainView,
      // 'slide-seckill': SlideSeckill,
    },
    data() {
      return {
        goodServiceInfo: {},
        // 轮播图
        slideContent: [],
        bannerHeight: '460px',
        touchStartX: 0,
        touchStartY: 0,
      };
    },
    created() {
      this.onSlideshow()
      this.updateBannerHeight()
    },
    mounted() {
      window.addEventListener('resize', this.updateBannerHeight)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateBannerHeight)
    },
    methods: {
      onSlideshow() {
        slideshow({ type: 'nav' }).then(res => {
          this.slideContent = res.data
        })
      },
      // 根据视口宽度恢复 H5 端轮播图高度。
      updateBannerHeight() {
        const width = window.innerWidth
        if (width < 640) {
          this.bannerHeight = Math.round((width - 32) * 0.52) + 'px'
        } else if (width < 1024) {
          this.bannerHeight = '280px'
        } else {
          this.bannerHeight = '460px'
        }
      },
      onTouchStart(e) {
        const touch = e.changedTouches && e.changedTouches[0]
        if (!touch) return
        this.touchStartX = touch.clientX
        this.touchStartY = touch.clientY
      },
      onTouchEnd(e) {
        const banner = this.$refs.banner
        const touch = e.changedTouches && e.changedTouches[0]
        if (!banner || !touch) return
        const dx = touch.clientX - this.touchStartX
        const dy = touch.clientY - this.touchStartY
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return
        dx < 0 ? banner.next() : banner.prev()
      }
    }
  };
</script>

<style scoped>
  #main-view {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding: 0 var(--page-gutter);
    overflow: hidden;
    touch-action: pan-y;
    -webkit-user-select: none;
    user-select: none;
  }

  #main-view>>>.el-carousel {
    border-radius: 12px;
    overflow: hidden;
  }

  #main-view>>>.el-carousel__arrow {
    display: none;
  }

  @media (max-width: 767px) {
    #main-view>>>.el-carousel__indicator--horizontal {
      padding: 12px 2px;
    }

    #main-view>>>.el-carousel__button {
      width: 18px;
    }
  }

  @media (min-width: 768px) {

    /* PC 端横幅按设计稿固定为 1280 × 460。 */
    #main-view {
      width: 1280px;
      height: 460px;
      margin: 0 auto;
      padding: 0;
    }

    #main-view>>>.el-carousel {
      width: 1280px;
      height: 460px;
    }

    #main-view>>>.el-carousel__arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    #main-view>>>.el-carousel__arrow i {
      display: block;
      line-height: 1;
    }
  }

  #main-view .carousel_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
    pointer-events: none;
    -webkit-user-drag: none;
  }

  @media (min-width: 768px) {
    #main-view .carousel_img {
      border-radius: 18px;
    }
  }

  #main-view .container {
    box-sizing: border-box;
    width: 100%;
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    /*border: 1px solid green;*/
    position: relative;
  }

  /* 顶部栏 */
  #main-view .container .top-bar {
    height: 40px;
    width: 100%;
    background-color: #aaa;
    position: relative;
    top: -40px;
    background-color: #fff;
  }

  #main-view .container .top-bar .all-product {
    /*display: inline-block;*/
    width: 15%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #129934;
    color: #fff;
    font-weight: bold;
    float: left;
  }

  #main-view .container .top-bar .topic-nav {
    float: left;
    margin-left: 20px;
  }

  #main-view .container .top-bar .topic-nav li {
    float: left;
    color: #424242;
    /*background-color: red;*/
    height: 20px;
    line-height: 20px;
    padding: 5px 20px;
    margin: 5px 0;
  }

  #main-view .container .top-bar .topic-nav li:hover {
    background-color: rgba(18, 171, 52, 0.9);
    cursor: pointer;
    border-radius: 15px;
  }

  #main-view .container .top-bar .topic-nav li a {
    color: #12ab34;
  }

  #main-view .container .top-bar .topic-nav li:hover a {
    color: #fff;
  }

  /* 主页面：轮播图 + 右边新闻*/
  #main-view .container .main-screen {
    width: 85%;
    height: 368px;
    position: absolute;
    top: 0px;
    left: 17%;
  }

  .main-screen-carousel {
    width: 676px;
    border-radius: 8px;
    overflow: hidden;
  }

  /* 右边生鲜咨询 */
  /* 下方slogan */
  #main-view .container .good-service {
    position: absolute;
    top: 420px;
  }
</style>


// WEBPACK FOOTER //
// src/view/home/components/MainView.vue